import { render, staticRenderFns } from "./BackgroundSelector.vue?vue&type=template&id=38b80eef&scoped=true"
import script from "./BackgroundSelector.vue?vue&type=script&lang=js"
export * from "./BackgroundSelector.vue?vue&type=script&lang=js"
import style0 from "./BackgroundSelector.vue?vue&type=style&index=0&id=38b80eef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b80eef",
  null
  
)

export default component.exports